import { useContext } from "react";

import DialogCustom from "components/DesignComponents/DialogCustom";
import RoutesContext from "context/routes/routesContext";

import DeviceStatisticsContent from "./DeviceStatisticsContent";

const DeviceStatisticsMobile = () => {
    const { isStatisticsOpen } = useContext(RoutesContext);

    return (
        <DialogCustom noPadding open={isStatisticsOpen}>
            <DeviceStatisticsContent
                permanentBorder
                contentPadding={"8px 16px"}
            />
        </DialogCustom>
    );
};

export default DeviceStatisticsMobile;
